import { useState } from 'react';
import { Eye, EyeOff, Mail, Lock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Input, Button } from '../ui';

export default function LoginForm({ email, password, setEmail, setPassword, handleSubmit, loading, error }) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-5" noValidate>
      <div className="flex flex-col gap-1 text-center">
        <h1 className="text-3xl font-bold text-text-primary">Bem-vindo</h1>
        <p className="text-sm text-text-muted">Entre na sua conta para agendar</p>
      </div>

      <div className="flex flex-col gap-4">
        <Input
          label="Email"
          type="email"
          placeholder="Digite seu email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          icon={Mail}
          required
          disabled={loading}
        />

        <div className="flex flex-col gap-1.5">
          <div className="relative">
            <Input
              label="Senha"
              type={showPassword ? 'text' : 'password'}
              placeholder="Digite sua senha"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              icon={Lock}
              required
              disabled={loading}
              className="pr-10"
            />
            <button
              type="button"
              onClick={() => setShowPassword((v) => !v)}
              aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
              className="absolute right-3 bottom-2.5 text-text-muted hover:text-text-primary transition-colors duration-normal focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus rounded"
            >
              {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
        </div>
      </div>

      {error && (
        <p role="alert" className="text-sm text-danger-text bg-danger-bg border border-danger rounded-md px-3 py-2">
          {error}
        </p>
      )}

      <Button type="submit" variant="primary" size="lg" loading={loading} className="w-full">
        Entrar
      </Button>

      <p className="text-center text-sm text-text-muted">
        Não tem conta?{' '}
        <Link to="/signup" className="text-primary hover:underline font-medium">
          Cadastre-se
        </Link>
      </p>
    </form>
  );
}
